exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (min-width: 400px) and(max-width: 500px) {\n  .individual-link {\n    margin: 0 1vw !important;\n  }\n}\n\n@media (max-width: 393px) {\n  .individual-link {\n    margin: 0 3.5vw !important;\n  }\n}\n\n@media (max-width: 362px) {\n  .individual-link {\n    margin: 0 1.9vw !important;\n  }\n}\n", ""]);

